import { useIsWithinModal } from "@@/modals/within-modal.context";
import { AccountIcon } from "@@/shared/account-icon";
import { ProviderHomeButton } from "@@/shared/buttons/provider-home.button";
import { HorizontalDivider } from "@@/shared/dividers";
import { FlexRow } from "@@/shared/flex-containers";
import { LanguagePicker } from "@@/shared/language-picker";
import { useTheme } from "@emotion/react";
import type { Provider } from "@towni/common";

const HoveringProductPageToolbar_SmallScreen = (props: {
    readonly provider: Provider;
}) => {
    const { provider } = props;
    const isWithinModal = useIsWithinModal();
    if (isWithinModal) return null;
    return (
        <FlexRow
            mainAxis="space-between"
            crossAxis="center"
            css={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                padding: 15,
                paddingLeft: 20,
                paddingRight: 20,
                minWidth: "100%",
                zIndex: 2,
            }}>
            <HoveringProductPageToolbar_Content_SmallScreen
                provider={provider}
            />
        </FlexRow>
    );
};

const HoveringProductPageToolbar_Content_SmallScreen = (props: {
    readonly provider: Provider;
}) => {
    const { provider } = props;
    const isWithinModal = useIsWithinModal();
    if (isWithinModal) return null;

    return (
        <>
            <FlexRow>
                <ProviderHomeButton provider={provider} />
            </FlexRow>
            <HorizontalDivider />
            <FlexRow>
                <LanguagePicker
                    type="mini-floating"
                    hideLabel
                    showLanguageNameInNative
                />
                <HorizontalDivider S />
                <AccountIcon />
            </FlexRow>
        </>
    );
};

const HoveringProductPageToolbar_Content_Desktop = (props: {
    readonly provider: Provider;
}) => {
    const theme = useTheme();
    const { provider } = props;
    const isWithinModal = useIsWithinModal();
    if (isWithinModal) return null;

    return (
        <>
            <FlexRow>
                <ProviderHomeButton
                    provider={provider}
                    disableShadow
                    color={theme.colors.black.light40}
                />
            </FlexRow>
            <HorizontalDivider />
            <FlexRow>
                <LanguagePicker
                    type="mini"
                    hideLabel
                    showLanguageNameInNative
                />
                <HorizontalDivider S />
                <AccountIcon disableShadow color={theme.colors.black.light40} />
            </FlexRow>
        </>
    );
};

export {
    HoveringProductPageToolbar_Content_Desktop,
    HoveringProductPageToolbar_Content_SmallScreen,
    HoveringProductPageToolbar_SmallScreen,
};
